import {
  ON_SAVE_FAILED_REQUEST_SUCCESS,
  ON_SAVE_FAILED_REQUEST_FAIL,
} from "../actions/types"

const INIT_STATE = {
  saveFailedRequestSuccess: false,
  saveFailedRequestFail: false,
}

const OfflineOperationsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ON_SAVE_FAILED_REQUEST_SUCCESS:
      return {
        saveFailedRequestSuccess: true,
        saveFailedRequestFail: false,
      }
    case ON_SAVE_FAILED_REQUEST_FAIL:
      return {
        saveFailedRequestSuccess: false,
        saveFailedRequestFail: true,
      }
    default:
      return state
  }
}

export default OfflineOperationsReducer
